import { BusinessLine } from '../types/definitions/vendor/graphql-schema.d';

/**
 * Validates that a return URL is a relative internal path, preventing open
 * redirects from crafted query params like ?returnUrl=https://attacker.example.
 * Returns the fallback if the value is absent, external, or protocol-relative.
 */
export const sanitizeReturnUrl = (
  value: string | string[] | undefined,
  fallback = '/gallery',
): string => {
  const raw = Array.isArray(value) ? value[0] : value;
  if (!raw) return fallback;

  try {
    const url = decodeURIComponent(raw);

    // Must start with a single forward slash
    if (!url.startsWith('/')) return fallback;

    // Block protocol-relative and absolute URLs
    if (/^(https?:)?\/\//i.test(url)) return fallback;

    // Block backslashes (edge-case bypass)
    if (url.includes('\\')) return fallback;

    // Optional: block weird edge cases like /\/evil
    if (/\/{2,}/.test(url)) return fallback;

    return url;
  } catch {
    return fallback;
  }
};

export type BusinessLineRoutes = 'women' | 'men';
export const businessLineToRoute = {
  WOMENS: 'women',
  MENS: 'men',
  KIDS: 'kids',
  SHELL: 'shell',
};
export const routeToBusinessLine: Record<string, BusinessLine> = {
  women: 'WOMENS',
  men: 'MENS',
  kids: 'KIDS',
  shell: 'SHELL',
};
export const routeToBusinessLineDisplay = (businessLine: BusinessLineRoutes) =>
  ({
    kids: 'Kids',
    men: 'Men',
    women: 'Women',
  }[businessLine]);

export const matchBusinessLineRoute = ({
  businessLine,
  route,
}: {
  businessLine: BusinessLine;
  route: BusinessLineRoutes;
}) => businessLineToRoute[businessLine] === route;
